export default __webpack_public_path__ + "static/Market-Segmentation-475e865130e428bcfb27498f3622593a.webp";